import React, { useState, useEffect } from 'react';
import moment from 'moment';
import redirectURL from '../redirectURL';

const CountdownTimer = ({ expirationTime, indent }) => {
  const indentId = indent.indent_id;

  const calculateTimeLeft = () => {
    const now = moment();
    const difference = moment(expirationTime).diff(now);

    if (difference > 0) {
      return {
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      return null;
    }
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);
  const [hasCalledAPI, setHasCalledAPI] = useState(false);

  // ✅ First check on mount
  useEffect(() => {
    if (!timeLeft && !hasCalledAPI) {
      callAPI();
    }
  }, []);

  useEffect(() => {
  const timer = setInterval(() => {
    const newTimeLeft = calculateTimeLeft();
    setTimeLeft(newTimeLeft);

    if (!newTimeLeft && !hasCalledAPI) {
      callAPI();
    }
  }, 1000); // Change from 60000 to 1000ms (1 sec)

  return () => clearInterval(timer);
}, [expirationTime, hasCalledAPI, indent]);

  const callAPI = () => {
    setHasCalledAPI(true);
    const params = { indent_id: indentId };

    if (!(indent.validity_end_time && indent.validity_end_time === 1)) {
      redirectURL
        .post('/consignments/getexpireddate', params)
        .then((resp) => {
          console.log(`API called successfully for indentId ${indentId}:`, resp);
        })
        .catch((err) => {
          console.error(`Error calling API for indentId ${indentId}:`, err);
        });
    }
  };

  return (
    <span style={{ marginLeft: '5px' }}>
      {!timeLeft ? (
        <span style={{color:'red'}}>00:00</span>
      ) : (
<span style={{color:'blue'}}>
  {String(timeLeft.hours).padStart(2, '0')}:
  {String(timeLeft.minutes).padStart(2, '0')}
</span>
      )}
    </span>
  );
};

export default CountdownTimer;
